import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    // Navigate to the login page with extras
    console.log('No longer authenticated');

    // clear all local storage of data
    localStorage.clear();

    // navigate back to the home page
    this.router.navigate(['/']);

    // return
    return false;
  }
}
